export default __webpack_public_path__ + "static/media/vip.458771a3.svg";